/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Hide_TreeInputs */

const cs_documents_hide_tree = /** @type {(inputs: Documents_Hide_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrýt složky`)
};

const en_documents_hide_tree = /** @type {(inputs: Documents_Hide_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide folders`)
};

/**
* | output |
* | --- |
* | "Hide folders" |
*
* @param {Documents_Hide_TreeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_hide_tree = /** @type {((inputs?: Documents_Hide_TreeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Hide_TreeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_hide_tree(inputs)
	return cs_documents_hide_tree(inputs)
});